declare const $: any;
export class store_carousel_controller {
    id: any;
    apiType: any;
    CurrentPage: any;
    items: any[];
    TotalItems: any;
    apiData: any
    apiMethod: any
    apiUrl: string;
    BaseUrlPage: any;
    carouselItems = [1, 2, 3, 4, 5, 6]
    constructor(private CarouselService, private $mPath, private $rootScope, private $timeout) {
        "ngInject"
    }

    $onInit() {
        this.$mPath.get().then(response => {
            this.BaseUrlPage = response;
            this.LoadData(1)
        })
    }
    LoadData(PageNumber) {
        let apiUrl = this.apiUrl + '&PageNumber=' + PageNumber;
        this.CarouselService.get(apiUrl, this.apiMethod, this.apiData).then(
            data => {

                this.TotalItems = data.data.TotalItems || 100;
                this.CurrentPage = PageNumber || 1;
                this.items = [];
                switch (this.apiType) {
                    case 'Search':
                        this.searchForEach(data);
                        break;
                    case 'Product':
                        this.productForEach(data);
                        break;
                    case 'Category':
                        this.categoryForEach(data);
                        break;
                }


            }
        )
    }

    searchForEach(data) {
        data.data.Products.map(item => {
            item.url = this.BaseUrlPage.StoreProductDetail + '/pID/' + item.ProductID + '/'
        })
        this.items = data.data.Products
        this.$rootScope.$emit('endLoading')
    }

    productForEach(data) {
        data.data.ProductList.map(item => {
            item.url = this.BaseUrlPage.StoreProductDetail + '/pID/' + item.ProductID + '/'
        })
        this.items = data.data.ProductList
        this.$rootScope.$emit('endLoading')
    }

    categoryForEach(data) {
        angular.forEach(data.data, function (val, key) {
            var item = {
                ImageFullPath: val.ImageUrl,
                url: this.BaseUrlPage.StoreListByCat + '/#/catID/' + val.CategoryID,
                Name: val.CategoryName,
            }
            this.items.push(item)
        })
        this.$rootScope.$emit('endLoading')
    }
}


// WEBPACK FOOTER //
// ./src/components/store-carousel/store-carousel.controller.ts